import React from 'react'
import ReactDOM from 'react-dom/client'
import LayereadyPlatform from '../layeready-platform.jsx'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <LayereadyPlatform />
  </React.StrictMode>,
)
